document.addEventListener("copy", (event) => {
  const regex = /^(http|https):\/\//;
  const pagelink = "\n\n" + pie_i18n.PIE_JS_MAIN_COPY_NOTE;
  event.preventDefault();
  event.clipboardData.setData("text", document.getSelection() + (!regex.test(document.getSelection()) ? pagelink : ""));
});